"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WS_TIMEOUT = void 0;
var WS_TIMEOUT = 30000;
exports.WS_TIMEOUT = WS_TIMEOUT;
//# sourceMappingURL=defaults.js.map


//////////////////
// WEBPACK FOOTER
// ./~/subscriptions-transport-ws/dist/defaults.js
// module id = ./node_modules/subscriptions-transport-ws/dist/defaults.js
// module chunks = 53 54